export default __webpack_public_path__ + "static/media/loading_indicator.fef9519a.svg";